import * as React from 'react'
import { useStore, companyStoreId } from 'stores'
import ShopLocationTableCore from '../ShopLocationTableCore'

const ShopLocationTable = (params) => {
  const companyStore = useStore(companyStoreId)
  const [locations, setLocations] = React.useState([])

  React.useEffect(() => {
    if (companyStore.getters.isProfileReady()) {
      companyStore.actions.fetchShopLocations()
    }
  }, [companyStore.getters.isProfileReady()])

  React.useEffect(() => {
    if (companyStore.getters.shopLocationList()) {
      setLocations(companyStore.getters.shopLocationList())
    }
  }, [companyStore.getters.shopLocationList()])

  return (
    <ShopLocationTableCore
      {...params}
      data={locations}
    />
  )
}

export default ShopLocationTable